module.exports = __webpack_public_path__ + "static/media/affiliates-copy-link.ce83da0e.gif";